import {
  Token_ANY_getInstance2irq9xt74psnv as Token_ANY_getInstance,
  Token_BOOLEAN_getInstance2lgd2p6it6acr as Token_BOOLEAN_getInstance,
  Token_STRING_getInstance1x248xxrskx54 as Token_STRING_getInstance,
  Token_NUMBER_getInstance3n6fh3qp39hkz as Token_NUMBER_getInstance,
  Token_LONG_getInstance1ss7l3se79ypx as Token_LONG_getInstance,
  Token_BEGIN_OBJECT_getInstance3cbczqvg43p6l as Token_BEGIN_OBJECT_getInstance,
  Token_BEGIN_ARRAY_getInstanceqey9u7uiztg7 as Token_BEGIN_ARRAY_getInstance,
  Token_NULL_getInstance2d65is50ce53 as Token_NULL_getInstance,
  Token_END_DOCUMENT_getInstancebw7c8jvmh8y9 as Token_END_DOCUMENT_getInstance,
  Token_END_OBJECT_getInstance2mjr75p0i0e8i as Token_END_OBJECT_getInstance,
  Token_END_ARRAY_getInstance3997flzdfgwf5 as Token_END_ARRAY_getInstance,
  Token_NAME_getInstance2t93ii37za3wz as Token_NAME_getInstance,
  JsonReaderhn8ohc8v7l9p as JsonReader,
} from './JsonReader.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { readAny17j2jqaxubdko as readAny } from './JsonReaders.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { JsonDataException2rdtm884tky1l as JsonDataException } from '../../exception/Exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toDoubleExact18clzpruqqw2d as toDoubleExact,
  toIntExact1n46an7ryabg9 as toIntExact,
  toIntExact1p16u7ro59o31 as toIntExact_0,
  toLongExact9cht6g9si07j as toLongExact,
  toIntExactOrNull6ky18km1ou13 as toIntExactOrNull,
  toIntExactOrNull2t2wdfvexswy6 as toIntExactOrNull_0,
  toLongExactOrNull3c5zyitei28os as toLongExactOrNull,
} from './internal/Utils.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function anyToToken($this, any) {
  var tmp;
  if (any == null) {
    tmp = Token_NULL_getInstance();
  } else {
    if (isInterface(any, KtList())) {
      tmp = Token_BEGIN_ARRAY_getInstance();
    } else {
      if (isInterface(any, KtMap())) {
        tmp = Token_BEGIN_OBJECT_getInstance();
      } else {
        if (typeof any === 'number') {
          tmp = Token_NUMBER_getInstance();
        } else {
          if (typeof any === 'bigint') {
            tmp = Token_LONG_getInstance();
          } else {
            if (typeof any === 'number') {
              tmp = Token_NUMBER_getInstance();
            } else {
              if (any instanceof JsonNumber()) {
                tmp = Token_NUMBER_getInstance();
              } else {
                if (typeof any === 'string') {
                  tmp = Token_STRING_getInstance();
                } else {
                  if (typeof any === 'boolean') {
                    tmp = Token_BOOLEAN_getInstance();
                  } else {
                    tmp = Token_ANY_getInstance();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function advanceIterator($this) {
  if ($this.stackSize_1 === 0) {
    $this.peekedToken_1 = Token_END_DOCUMENT_getInstance();
    return Unit_instance;
  }
  var currentIterator = ensureNotNull($this.iteratorStack_1[$this.stackSize_1 - 1 | 0]);
  var tmp = $this.path_1[$this.stackSize_1 - 1 | 0];
  if (!(tmp == null) ? typeof tmp === 'number' : false) {
    var tmp_0 = $this.path_1;
    var tmp_1 = $this.stackSize_1 - 1 | 0;
    var tmp_2 = $this.path_1[$this.stackSize_1 - 1 | 0];
    tmp_0[tmp_1] = ((!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE()) + 1 | 0;
  }
  if (currentIterator.hasNext_bitz1p_k$()) {
    var next = currentIterator.next_20eer_k$();
    $this.peekedData_1 = next;
    var tmp_3 = $this;
    var tmp_4;
    if (!(next == null) ? isInterface(next, Entry()) : false) {
      tmp_4 = Token_NAME_getInstance();
    } else {
      tmp_4 = anyToToken($this, next);
    }
    tmp_3.peekedToken_1 = tmp_4;
  } else {
    var tmp_5 = $this;
    var tmp_6;
    var tmp_7 = $this.path_1[$this.stackSize_1 - 1 | 0];
    if (!(tmp_7 == null) ? typeof tmp_7 === 'number' : false) {
      tmp_6 = Token_END_ARRAY_getInstance();
    } else {
      tmp_6 = Token_END_OBJECT_getInstance();
    }
    tmp_5.peekedToken_1 = tmp_6;
  }
}
function increaseStack($this) {
  if ($this.stackSize_1 === $this.path_1.length) {
    $this.path_1 = copyOf($this.path_1, imul($this.path_1.length, 2));
    $this.containerStack_1 = copyOf($this.containerStack_1, imul($this.containerStack_1.length, 2));
    $this.nameIndexStack_1 = copyOf_0($this.nameIndexStack_1, imul($this.nameIndexStack_1.length, 2));
    $this.iteratorStack_1 = copyOf($this.iteratorStack_1, imul($this.iteratorStack_1.length, 2));
  }
  $this.stackSize_1 = $this.stackSize_1 + 1 | 0;
}
function findName($this, needle, haystack) {
  var expectedIndex = $this.nameIndexStack_1[$this.stackSize_1 - 1 | 0];
  if (expectedIndex < haystack.get_size_woubt6_k$() && haystack.get_c1px32_k$(expectedIndex) === needle) {
    $this.nameIndexStack_1[$this.stackSize_1 - 1 | 0] = $this.nameIndexStack_1[$this.stackSize_1 - 1 | 0] + 1 | 0;
    return expectedIndex;
  } else {
    var index = haystack.indexOf_si1fv9_k$(needle);
    if (!(index === -1)) {
      $this.nameIndexStack_1[$this.stackSize_1 - 1 | 0] = index + 1 | 0;
    }
    return index;
  }
}
function getPathAsString($this) {
  return joinToString($this.getPath_18su3p_k$(), '.');
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      buffer_6f86a9_k$(_this__u8e3s4) {
        if (_this__u8e3s4 instanceof MapJsonReader())
          return _this__u8e3s4;
        var token = _this__u8e3s4.peek_21nx7_k$();
        // Inline function 'kotlin.check' call
        if (!token.equals(Token_BEGIN_OBJECT_getInstance())) {
          var message = 'Failed to buffer json reader, expected `BEGIN_OBJECT` but found `' + token.toString() + '` json token';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        var pathRoot = _this__u8e3s4.getPath_18su3p_k$();
        var tmp = readAny(_this__u8e3s4);
        var data = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
        // Inline function 'kotlin.apply' call
        var this_0 = new (MapJsonReader())(data, pathRoot);
        this_0.ignoreUnknownKeys_132xpl_k$(this_0.ignoreUnknownKeys_scm7n0_k$());
        return this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var MapJsonReaderClass;
function MapJsonReader() {
  if (MapJsonReaderClass === VOID) {
    class $ {
      constructor(root, pathRoot) {
        pathRoot = pathRoot === VOID ? emptyList() : pathRoot;
        this.root_1 = root;
        this.pathRoot_1 = pathRoot;
        this.peekedData_1 = null;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.path_1 = Array(64);
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_0.containerStack_1 = Array(64);
        var tmp_1 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_1.iteratorStack_1 = Array(64);
        this.nameIndexStack_1 = new Int32Array(64);
        this.stackSize_1 = 0;
        this.ignoreUnknownKeys_1 = true;
        this.peekedToken_1 = anyToToken(this, this.root_1);
        this.peekedData_1 = this.root_1;
      }
      beginArray_hxn19s_k$() {
        // Inline function 'kotlin.apply' call
        if (!this.peek_21nx7_k$().equals(Token_BEGIN_ARRAY_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected BEGIN_ARRAY but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.peekedData_1;
        var currentValue = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : THROW_CCE();
        increaseStack(this);
        this.path_1[this.stackSize_1 - 1 | 0] = -1;
        this.iteratorStack_1[this.stackSize_1 - 1 | 0] = currentValue.iterator_jk1svi_k$();
        advanceIterator(this);
        return this;
      }
      endArray_s2tmpq_k$() {
        // Inline function 'kotlin.apply' call
        if (!this.peek_21nx7_k$().equals(Token_END_ARRAY_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected END_ARRAY but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        this.stackSize_1 = this.stackSize_1 - 1 | 0;
        this.iteratorStack_1[this.stackSize_1] = null;
        this.path_1[this.stackSize_1] = null;
        advanceIterator(this);
        return this;
      }
      beginObject_5wddq0_k$() {
        // Inline function 'kotlin.apply' call
        if (!this.peek_21nx7_k$().equals(Token_BEGIN_OBJECT_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected BEGIN_OBJECT but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        increaseStack(this);
        var tmp = this.containerStack_1;
        var tmp_0 = this.stackSize_1 - 1 | 0;
        var tmp_1 = this.peekedData_1;
        tmp[tmp_0] = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
        this.rewind_xb9q0b_k$();
        return this;
      }
      endObject_ofuv3u_k$() {
        // Inline function 'kotlin.apply' call
        this.stackSize_1 = this.stackSize_1 - 1 | 0;
        this.iteratorStack_1[this.stackSize_1] = null;
        this.path_1[this.stackSize_1] = null;
        this.containerStack_1[this.stackSize_1] = null;
        advanceIterator(this);
        return this;
      }
      hasNext_bitz1p_k$() {
        switch (this.peek_21nx7_k$().ordinal_1) {
          case 3:
            return false;
          case 1:
            return false;
          default:
            return true;
        }
      }
      peek_21nx7_k$() {
        return this.peekedToken_1;
      }
      nextName_njxula_k$() {
        if (!this.peek_21nx7_k$().equals(Token_NAME_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected NAME but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.peekedData_1;
        var data = (!(tmp == null) ? isInterface(tmp, Entry()) : false) ? tmp : THROW_CCE();
        this.path_1[this.stackSize_1 - 1 | 0] = data.get_key_18j28a_k$();
        this.peekedData_1 = data.get_value_j01efc_k$();
        this.peekedToken_1 = anyToToken(this, data.get_value_j01efc_k$());
        return data.get_key_18j28a_k$();
      }
      nextString_kwkc9o_k$() {
        var value = this.peekedData_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value.toString();
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value.toString();
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value.toString();
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = value;
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = value.value_1;
                } else {
                  throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected a String but got ' + toString_0(value) + ' instead');
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      nextBoolean_nfdk1h_k$() {
        if (!this.peek_21nx7_k$().equals(Token_BOOLEAN_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected BOOLEAN but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.peekedData_1;
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
        advanceIterator(this);
        return this_0;
      }
      nextNull_njy9ei_k$() {
        if (!this.peek_21nx7_k$().equals(Token_NULL_getInstance())) {
          throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected NULL but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        advanceIterator(this);
        return null;
      }
      nextDouble_s2xvfg_k$() {
        switch (this.peek_21nx7_k$().ordinal_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected a Double but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.peekedData_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toDoubleExact(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value;
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toDouble(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toDouble(value.value_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected a Double but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      nextInt_ujorgc_k$() {
        switch (this.peek_21nx7_k$().ordinal_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected an Int but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.peekedData_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toIntExact_0(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toIntExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toInt(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toInt(value.value_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected an Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      nextLong_njwv0v_k$() {
        switch (this.peek_21nx7_k$().ordinal_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected a Long but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.peekedData_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = fromInt(value);
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value;
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toLongExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toLong(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toLong(value.value_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      nextNumber_n9bzz8_k$() {
        switch (this.peek_21nx7_k$().ordinal_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$('Expected a Number but was ' + this.peek_21nx7_k$().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.peekedData_1;
        var tmp;
        var tmp_0;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp_1 = true;
          } else {
            tmp_1 = !(value == null) ? typeof value === 'number' : false;
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          tmp = new (JsonNumber())(toString(value));
        } else {
          if (!(value == null) ? typeof value === 'string' : false) {
            tmp = new (JsonNumber())(value);
          } else {
            if (value instanceof JsonNumber()) {
              tmp = value;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Expected JsonNumber but got ' + toString_0(value) + ' instead';
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      nextGuessedNumber_kuqb75_k$() {
        var value = this.peekedData_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          var tmp0_elvis_lhs = toIntExactOrNull_0(value);
          var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toLongExactOrNull(value) : tmp0_elvis_lhs;
          tmp = tmp1_elvis_lhs == null ? value : tmp1_elvis_lhs;
        } else {
          if (!(value == null) ? typeof value === 'number' : false) {
            tmp = value;
          } else {
            if (!(value == null) ? typeof value === 'bigint' : false) {
              var tmp2_elvis_lhs = toIntExactOrNull(value);
              tmp = tmp2_elvis_lhs == null ? value : tmp2_elvis_lhs;
            } else {
              if (value instanceof JsonNumber()) {
                var asString = value.value_1;
                var tmp3_elvis_lhs = toIntOrNull(asString);
                var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? toLongOrNull(asString) : tmp3_elvis_lhs;
                var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? toDoubleOrNull(asString) : tmp4_elvis_lhs;
                tmp = tmp5_elvis_lhs == null ? value : tmp5_elvis_lhs;
              } else {
                if (!(value == null) ? typeof value === 'string' : false) {
                  var asString_0 = value;
                  var tmp6_elvis_lhs = toIntOrNull(asString_0);
                  var tmp7_elvis_lhs = tmp6_elvis_lhs == null ? toLongOrNull(asString_0) : tmp6_elvis_lhs;
                  var tmp8_elvis_lhs = tmp7_elvis_lhs == null ? toDoubleOrNull(asString_0) : tmp7_elvis_lhs;
                  tmp = tmp8_elvis_lhs == null ? new (JsonNumber())(asString_0) : tmp8_elvis_lhs;
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected a Number but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
                }
              }
            }
          }
        }
        var result = tmp;
        advanceIterator(this);
        return result;
      }
      skipValue_18u2ci_k$() {
        advanceIterator(this);
      }
      close_yn9xrc_k$() {
      }
      selectName_o4466z_k$(names) {
        while (this.hasNext_bitz1p_k$()) {
          var name = this.nextName_njxula_k$();
          var index = findName(this, name, names);
          if (!(index === -1)) {
            return index;
          }
          if (!this.ignoreUnknownKeys_1) {
            throw JsonDataException().new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$("Unknown key '" + name + "' found at path: '" + getPathAsString(this) + "'");
          }
          this.skipValue_18u2ci_k$();
        }
        return -1;
      }
      rewind_xb9q0b_k$() {
        var container = this.containerStack_1[this.stackSize_1 - 1 | 0];
        this.path_1[this.stackSize_1 - 1 | 0] = null;
        var tmp = this.iteratorStack_1;
        var tmp_0 = this.stackSize_1 - 1 | 0;
        // Inline function 'kotlin.collections.iterator' call
        tmp[tmp_0] = ensureNotNull(container).get_entries_p20ztl_k$().iterator_jk1svi_k$();
        this.nameIndexStack_1[this.stackSize_1 - 1 | 0] = 0;
        advanceIterator(this);
      }
      getPath_18su3p_k$() {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        result.addAll_h3ej1q_k$(this.pathRoot_1);
        var inductionVariable = 0;
        var last = this.stackSize_1;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_safe_receiver = this.path_1[index];
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              result.add_utx5q5_k$(tmp0_safe_receiver);
            }
          }
           while (inductionVariable < last);
        return result;
      }
      ignoreUnknownKeys_scm7n0_k$() {
        return this.ignoreUnknownKeys_1;
      }
      ignoreUnknownKeys_132xpl_k$(ignoreUnknownKeys) {
        this.ignoreUnknownKeys_1 = ignoreUnknownKeys;
      }
    }
    initMetadataForClass($, 'MapJsonReader', VOID, VOID, [JsonReader()]);
    MapJsonReaderClass = $;
  }
  return MapJsonReaderClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  MapJsonReader as MapJsonReader2b7ri7r44421y,
  Companion_instance as Companion_instance31iaet2guytyg,
};
//endregion

//# sourceMappingURL=MapJsonReader.mjs.map
